import firebase from '../../lib/firebase.prod';
import { createRole } from './createRole.api';

const firebaseRef = firebase.database();

export async function saveAccessibility(
	projectId,
	roleName,
	accessibilityCheckbox,
	color
) {
	let result = await createRole(
		projectId,
		roleName,
		accessibilityCheckbox,
		color
	);
	if (!result.success) {
		return {
			success: false,
		};
	}

	if (!result.roleId) {
		return {
			success: false,
		};
	}

	return {
		success: true,
		roleId: result.roleId,
	};
}
